export type BookDocumentType =
  | 'COVER'
  | 'INDEX'
  | 'INSPECTION_DATA'
  | 'CHECKLIST'
  | 'INTEGRITY_REPORT'
  | 'RECOMMENDATIONS'
  | 'ME_REPORT'
  | 'LP_REPORT'
  | 'PM_REPORT'
  | 'BSCAN_REPORT'
  | 'OTHER_NDT'
  | 'AVR'
  | 'PHOTO_REPORT'
  | 'SKETCH'
  | 'DRAWINGS'
  | 'LINE_LIST'
  | 'ISOMETRICS'
  | 'PIT'
  | 'FLOW_DIAGRAM'
  | 'MAINTENANCE_DOCS'
  | 'REFERENCE_DOCS'
  | 'ATTACHMENTS'
  | 'OTHER';

export type BookDocumentCategory =
  | 'REPORT'
  | 'CHECKLIST'
  | 'DRAWING'
  | 'ISOMETRIC'
  | 'LINE_LIST'
  | 'PIT'
  | 'FLOW_DIAGRAM'
  | 'PHOTO'
  | 'SKETCH'
  | 'CALCULATION'
  | 'REFERENCE'
  | 'ATTACHMENT'
  | 'OTHER';

export interface BookTemplateItemConfig {
  readonly documentType: BookDocumentType;
  readonly defaultTitle: string;
  readonly category: BookDocumentCategory;
  readonly defaultRequired: boolean;
  readonly allowNotApplicable: boolean;
  readonly order: number;
  readonly isSystemGenerated: boolean;
}

export interface InspectionBookTemplate {
  readonly id: string;
  readonly name: string;
  readonly equipmentType?: string; // PRESSURE_VESSEL, TANK, PIPING, BOILER, etc.
  readonly inspectionType?: string;
  readonly version: string;
  readonly items: readonly BookTemplateItemConfig[];
}

export const DEFAULT_BOOK_TEMPLATE_ITEMS: readonly BookTemplateItemConfig[] = [
  { documentType: 'COVER', defaultTitle: 'Capa do Book de Inspeção', category: 'OTHER', defaultRequired: true, allowNotApplicable: false, order: 1, isSystemGenerated: true },
  { documentType: 'INDEX', defaultTitle: 'Índice do Book e Paginação', category: 'OTHER', defaultRequired: true, allowNotApplicable: false, order: 2, isSystemGenerated: true },
  { documentType: 'INSPECTION_DATA', defaultTitle: 'Dados Gerais da Inspeção e Equipamento', category: 'REPORT', defaultRequired: true, allowNotApplicable: false, order: 3, isSystemGenerated: true },
  { documentType: 'CHECKLIST', defaultTitle: 'Checklist de Inspeção Visual (NR-13)', category: 'CHECKLIST', defaultRequired: true, allowNotApplicable: false, order: 4, isSystemGenerated: true },
  { documentType: 'INTEGRITY_REPORT', defaultTitle: 'Relatório de Integridade — RI (NR-13)', category: 'REPORT', defaultRequired: true, allowNotApplicable: false, order: 5, isSystemGenerated: true },
  { documentType: 'RECOMMENDATIONS', defaultTitle: 'Recomendações de Inspeção e Prazos', category: 'REPORT', defaultRequired: true, allowNotApplicable: false, order: 6, isSystemGenerated: true },
  { documentType: 'ME_REPORT', defaultTitle: 'Relatório de Medição de Espessura (ME - Ultrassom)', category: 'REPORT', defaultRequired: false, allowNotApplicable: true, order: 7, isSystemGenerated: true },
  { documentType: 'LP_REPORT', defaultTitle: 'Relatório de Ensaio por Líquido Penetrante (LP)', category: 'REPORT', defaultRequired: false, allowNotApplicable: true, order: 8, isSystemGenerated: true },
  { documentType: 'PM_REPORT', defaultTitle: 'Relatório de Ensaio por Partícula Magnética (PM)', category: 'REPORT', defaultRequired: false, allowNotApplicable: true, order: 9, isSystemGenerated: true },
  { documentType: 'BSCAN_REPORT', defaultTitle: 'Relatório de Varredura B-Scan Automatizado', category: 'REPORT', defaultRequired: false, allowNotApplicable: true, order: 10, isSystemGenerated: true },
  { documentType: 'OTHER_NDT', defaultTitle: 'Outros Relatórios de Ensaios Não Destrutivos (END)', category: 'REPORT', defaultRequired: false, allowNotApplicable: true, order: 11, isSystemGenerated: false },
  { documentType: 'AVR', defaultTitle: 'Avaliação de Vida Remanescente (AVR)', category: 'CALCULATION', defaultRequired: false, allowNotApplicable: true, order: 12, isSystemGenerated: true },
  { documentType: 'PHOTO_REPORT', defaultTitle: 'Relatório / Registro Fotográfico e Evidências', category: 'PHOTO', defaultRequired: true, allowNotApplicable: false, order: 13, isSystemGenerated: true },
  { documentType: 'SKETCH', defaultTitle: 'Croquis e Esquemas Estruturais', category: 'SKETCH', defaultRequired: false, allowNotApplicable: true, order: 14, isSystemGenerated: false },
  { documentType: 'DRAWINGS', defaultTitle: 'Desenhos Técnicos (Geral, Fabricação, Reparo)', category: 'DRAWING', defaultRequired: false, allowNotApplicable: true, order: 15, isSystemGenerated: false },
  { documentType: 'LINE_LIST', defaultTitle: 'Lista de Linhas do Sistema', category: 'LINE_LIST', defaultRequired: false, allowNotApplicable: true, order: 16, isSystemGenerated: false },
  { documentType: 'ISOMETRICS', defaultTitle: 'Isométricos de Inspeção (1:N)', category: 'ISOMETRIC', defaultRequired: false, allowNotApplicable: true, order: 17, isSystemGenerated: false },
  { documentType: 'PIT', defaultTitle: 'Plano de Inspeção e Teste — PIT', category: 'PIT', defaultRequired: false, allowNotApplicable: true, order: 18, isSystemGenerated: false },
  { documentType: 'FLOW_DIAGRAM', defaultTitle: 'Fluxogramas de Processo / P&ID', category: 'FLOW_DIAGRAM', defaultRequired: false, allowNotApplicable: true, order: 19, isSystemGenerated: false },
  { documentType: 'MAINTENANCE_DOCS', defaultTitle: 'Documentos e Históricos de Manutenção', category: 'REFERENCE', defaultRequired: false, allowNotApplicable: true, order: 20, isSystemGenerated: false },
  { documentType: 'REFERENCE_DOCS', defaultTitle: 'Documentos e Procedimentos de Referência', category: 'REFERENCE', defaultRequired: false, allowNotApplicable: true, order: 21, isSystemGenerated: false },
  { documentType: 'ATTACHMENTS', defaultTitle: 'Anexos Complementares e Certificados', category: 'ATTACHMENT', defaultRequired: false, allowNotApplicable: true, order: 22, isSystemGenerated: false },
  { documentType: 'OTHER', defaultTitle: 'Outros Documentos Definidos pelo Projeto', category: 'OTHER', defaultRequired: false, allowNotApplicable: true, order: 23, isSystemGenerated: false },
];
